import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=52ff1e9a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ff1e9a')) {
      api.createRecord('52ff1e9a', component.options)
    } else {
      api.reload('52ff1e9a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=52ff1e9a&", function () {
      api.rerender('52ff1e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s02Cl9xpJo5s/JS/comp/childrenage.vue"
export default component.exports